<template>
    <card-seplag titulo='Ver Ciclos'>
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo cols="12 3">
                    <Button label="Criar Novo Ciclo" class="botao" @click="paginaCadastrarEditar(false)" />
                </Rotulo>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-grid p-fluid center">
                <table-seplag :dados.sync="this.tabela.ciclosExistentes" :campos="this.tabela.camposTabela"
                    :hasEventoAcao="true" :rows="10" :paginacao="true" :totalRegistro.sync="this.tabela.totalRegistro">
                    <Column header="Editar" headerStyle="width: 2.vw; " bodyStyle=" ">
                        <template #body="slotProps">
                            <div class="p-col-12 p-md-12 p-lg-12 ">
                                <Button class="p-button-warning" icon="pi pi-user-edit"
                                    @click="paginaCadastrarEditar(slotProps.data)" />
                            </div>
                        </template>
                    </Column>
                    <Column header="Excluir" headerStyle="width: 2.vw; " bodyStyle=" ">
                        <template #body="slotProps">
                            <div class="p-col-12 p-md-12 p-lg-12 ">
                                <Button class="p-button-danger" icon="pi pi-times"
                                    @click="abrirModalExcluir(slotProps.data)" />
                            </div>
                        </template>
                    </Column>
                </table-seplag>
            </div>
        </div>
        <Dialog :header="modal.titulo" v-if="modal.exibirExcluir" :visible.sync="modal.exibirExcluir" :modal="true"
            :contentStyle="'min-width:30rem;min-height: 10rem;'">
            <div class="center">
                <p>Deseja realmente excluir o<strong> Ciclo?</strong></p>
            </div>
            <div class="p-col-12 ">
                <div class="p-grid p-fluid center">
                    <Rotulo cols="12 4">
                        <Button label="Não" class="botao " @click="fecharModal()" />
                    </Rotulo>
                    <Rotulo cols="12 4">
                        <Button label="Sim, excluir!" class="botao p-button-danger"
                            @click="excluirCicloLogicamente()" />
                    </Rotulo>
                </div>
            </div>
        </Dialog>
    </card-seplag>
</template>

<script>
import { baseApiUrl } from "@/config/global";
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";

export default {
    components: { TableSeplag, Rotulo, CardSeplag },
    data: function () {
        return {
            url: {
                excluirLogicamente: "/ciclos",
                salvarURL: "/paramassuntoemail",
                listarCiclos: "/ciclos/all"
            },
            dropdown: {
                tipoAssuntoSelecionado: null,
                tipoAssuntoList: [],
                assuntoSelecionado: null,
                assuntoList: [],
                orgaoSelecionado: null,
                orgaoList: [],
            },
            tabela: {
                ciclosExistentes: [],
                totalRegistro: 0,
                camposTabela: [
                    { nome: 'exercicio.ano', titulo: 'Exercício ', tamanho: '5.vw', alinhamento: "left" },
                    { nome: 'descCiclo', titulo: 'Nome do Ciclo', tamanho: '12.vw', alinhamento: "left" },
                    { nome: 'termo.descTermo', titulo: 'Termo', tamanho: '12.vw', alinhamento: "left" },
                    { nome: 'questionario.descQuestionario', titulo: 'Questionario', tamanho: '12.vw', alinhamento: "left" },
                    { nome: 'dataInicio', titulo: 'Data de Inicio', tamanho: '10.vw', alinhamento: "left" },
                    { nome: 'dataFinal', titulo: 'Data de Encerramento', tamanho: '10.vw', alinhamento: "left" },
                    { nome: 'statCiclo', titulo: 'Status', tamanho: '8.vw', alinhamento: "left" },
                ]
            },
            modal: {
                titulo: null,
                especie: null,
                exibir: false,
                exibirExcluir: false,
                item: null
            },
        }
    },
    methods: {
        async carregarDados() {
            this.listarCiclos()
        },
        abrirModalExcluir(data) {
            this.modal.item = data
            this.modal.exibirExcluir = true
            this.modal.titulo = `Excluir Ciclo: ${data.descCiclo}`
        },
        fecharModal() {
            this.modal.exibir = false
            this.modal.exibirExcluir = false
            this.modal.item = null
            this.modal.titulo = null
            this.modal.especie = null
        },
        paginaCadastrarEditar(data) {
            this.$store.commit("setCicloEditarDados", data)
            this.$router.push('/' + process.env.VUE_APP_BASE_URL + '/ciclos' )
        },
        listarCiclos() {
            this.$http.get(`${baseApiUrl}${this.url.listarCiclos}`).then(res => {
                this.tabela.ciclosExistentes = res.data
            })
        },
        removerElementoDaLista(idenCiclo) {
            let list = []
            for (let obj of this.tabela.ciclosExistentes) {
                if (obj.idenCiclo !== idenCiclo) {
                    list.push(obj)
                }
            }
            this.tabela.ciclosExistentes = list
        },
        excluirCicloLogicamente() {
            this.$http.delete(`${baseApiUrl}${this.url.excluirLogicamente}/${this.modal.item.idenCiclo}`).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ciclo deletado com sucesso', life: 1000 })
                this.removerElementoDaLista(this.modal.item.idenCiclo)
                this.fecharModal()
            })
        },
    },
    mounted() {
        this.carregarDados()
    }
}
</script>

<style scoped>
.center {
    justify-content: center;
    text-align: center;
    align-items: center;
}
</style>